import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxCardComponent } from './components';
import { AtxRouterTabsModule } from '../../other';

@NgModule({
    imports: [
        CommonModule,
        AtxRouterTabsModule,
    ],
    declarations: [
        AtxCardComponent,
    ],
    exports: [
        AtxCardComponent,
    ]
})

export class AtxCardModule {}
